<div *ngIf="pageLoading" class="loader text-center">
	<img src="../assets/img/loading.gif" />
</div>
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm" *ngIf="UserModuleAccess==='Full'">
	<div class="row mb-2">
		<div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
			<ng-select id="category_id" [items]="allCategories" bindLabel="name" bindValue="id" [clearable]="true"
				placeholder="Category*" formControlName="category_id" [multiple]="false" appearance="outline"
				[ngClass]="{'is-invalid':showError('category_id')}">
			</ng-select>
			<p *ngIf="showError('category_id')" class="text-danger">
				<span *ngIf="f.category_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.category_id.errors?.incorrect">
					{{customError.category_id}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2" *ngIf="uId">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('question_name')}" id="question_name"
					formControlName="question_name" placeholder="">
				<label for="question_name">Question*</label>
			</div>
			<p *ngIf="showError('question_name')" class="text-danger">
				<span *ngIf="f.question_name.errors?.required">
					Required
				</span>
				<span *ngIf="f.question_name.errors?.incorrect">
					{{customError.question_name}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-2" *ngIf="!uId">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th style="width: 95%;">
							Question
							<span class="text-danger">*</span>
						</th>
						<th style="width: 5%;" class="text-center">
							@if(!uId){
							<button type="button" (click)="addRow()" class="btn btn-xs btn-outline-primary"
								matTooltip="Add">
								<fa-icon [icon]="['fas', 'plus']"></fa-icon>
							</button>
							}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr formArrayName="questions" *ngFor="let creds of get_rows.controls; let i = index">
						<ng-container [formGroupName]="i">
							<td>
								<input class="form-control" [ngClass]="{'is-invalid':showError2(i,'question_name')}"
									id="question_name" formControlName="question_name" placeholder="Question...">
								<p *ngIf="showError2(i,'question_name')" class="text-danger">
									<span *ngIf="creds.get('question_name')?.errors?.required">
										Required
									</span>
								</p>
							</td>
							<td class="text-center">
								<button type="button" (click)="deleteRow(i)" class="btn btn-xs btn-outline-danger mt-2"
									matTooltip="Remove">
									<fa-icon [icon]="['fas', 'times']"></fa-icon>
								</button>
							</td>
						</ng-container>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<!-- <button type="button" (click)="addRow()" class="btn btn-sm btn-outline-primary me-1" *ngIf="!uId">
				<fa-icon [icon]="['fas', 'plus']"></fa-icon>
				Add
			</button> -->
			<button type="submit" class="btn btn-sm btn-outline-success me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-outline-dark" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
<div *ngIf="UserModuleAccess!=='Full'">
	<h3 class="text-center">You don't have access to this section.</h3>
</div>